export default function AdminV2Settings() {
  return (
    <div className="tw-space-y-6">
      <section className="admin-v2-panel tw-p-6 lg:tw-p-8">
        <div className="tw-max-w-3xl tw-space-y-3">
          <p className="admin-v2-eyebrow">System settings</p>
          <h1 className="admin-v2-title">Brand and system settings</h1>
          <p className="admin-v2-subtitle">
            This surface keeps Admin 2.0 aligned with the Cardly brand guideline, using the approved navy, coral, and yellow palette.
          </p>
        </div>
      </section>

      <section className="admin-v2-soft-panel tw-p-4 lg:tw-p-6">
        <div className="tw-grid tw-gap-4 md:tw-grid-cols-3">
          {[
            { name: "Primary Navy", value: "#2C3255", note: "Sidebar, headings, dense UI control" },
            { name: "Coral Accent", value: "#F35658", note: "Primary action, urgent states, focus" },
            { name: "Signal Yellow", value: "#FAD845", note: "Highlights, active chips, card warmth" },
          ].map((color) => (
            <div key={color.value} className="admin-v2-stat-panel">
              <div className="tw-h-24 tw-rounded-[18px]" style={{ backgroundColor: color.value }} />
              <p className="tw-mt-4 tw-text-sm tw-font-semibold admin-v2-text-strong">{color.name}</p>
              <p className="tw-text-sm admin-v2-text-muted">{color.value}</p>
              <p className="tw-mt-2 tw-text-sm admin-v2-text-muted">{color.note}</p>
            </div>
          ))}
        </div>

        <div className="admin-v2-brand-band tw-mt-4 tw-rounded-[22px] tw-p-4 sm:tw-p-5">
          <p className="admin-v2-eyebrow tw-mb-2">UI guidance</p>
          <div className="tw-grid tw-gap-3 md:tw-grid-cols-3">
            <div className="admin-v2-key-value">
              <dt>Layout</dt>
              <dd>Calm surfaces, sidebar-led navigation, mobile cards for narrow screens.</dd>
            </div>
            <div className="admin-v2-key-value">
              <dt>Actions</dt>
              <dd>Coral primary buttons, restrained secondary actions, minimal extra colors.</dd>
            </div>
            <div className="admin-v2-key-value">
              <dt>States</dt>
              <dd>Yellow for attention, coral for urgent issues, navy for steady information.</dd>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
